var map = {
	"./CopyrightKJHZ.svg": 3092,
	"./KJHZ_Logo.svg": 307,
	"./emper_tools_gmbh_copyright.svg": 1628,
	"./fuchsbau_logo_login.png": 4141,
	"./fuchsbau_logo_login.svg": 7595,
	"./garsena_logo.png": 9011,
	"./garsena_logo.svg": 9831,
	"./garsena_logo_login.png": 2157,
	"./garsena_logo_login.svg": 7425,
	"./kjd-belleben-logo.svg": 3005,
	"./kjhz_logo.png": 3333
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4336;